import { intl } from 'core/src/intl';
import SSView from 'core/src/views/base/ss-view';
import UserListPopupView from 'core/src/views/popups/user-list-popup';

const ProfileSnippetView = SSView.extend({

  el: '.profile-snippet',

  events: {
    'click .stat.followers': 'onFollowersClick',
    'click .stat.following': 'onFollowingClick',
  },

  initialize: function() {
    this.listenTo(SS.currentUser, 'updateNumFollowing', function(count) {
      this.$('.stat.following .number').text((count === '0') ? ' -- ' : count);
    });

    SSView.prototype.initialize.apply(this, arguments);
  },

  onFollowersClick: function() {
    this.showPopup('followers');
  },

  onFollowingClick: function() {
    this.showPopup('following');
  },

  showPopup: function(type) {
    const currentUserUid = SS.currentUser.get('id');
    const { firstName } = SS.serverBootstrap.userData;
    const url = '/users/' + currentUserUid + '/' + type;
    const updateCount = type === 'following';

    const text = {
      'followers': {
        emptyMsg: intl.formatMessage({
          id: 'profile-snippet.no-followers-message',
          defaultMessage: 'No one is following {firstName} yet.',
          description: 'Message when you don\'t have followers'
        },{
          'firstName':firstName,
        }),
        title: intl.formatMessage({
          id: 'profile-snippet.followers-title',
          defaultMessage: 'Followers',
          description: 'Followers Title Text'
        }),
      },
      'following': {
        emptyMsg: intl.formatMessage({
          id: 'profile-snippet.no-following-message',
          defaultMessage: '{firstName} isn\'t following anyone yet',
          description: 'Message when you are not following anyone.'
        },{
          'firstName':firstName,
        }), 
        title: intl.formatMessage({
          id: 'profile-snippet.following-title',
          defaultMessage: 'Following',
          description: 'Following Title Text'
        }),
      },
    };

    new UserListPopupView({
      url: url,
      title: text[type].title,
      emptyMessage: text[type].emptyMsg,
      updateCount: updateCount,
    });
  },
});

export default ProfileSnippetView;


